import axiosClient from ".";
class GameHistoryAPI {
  static getGameHistory() {
    return axiosClient.get("/game_history.json");
  }
}
export default GameHistoryAPI;
